export default "__VITE_ASSET__03f71cc9__"